
import { isObject } from 'vessel/utils'
import { get } from 'vuex-pathify'

export default {
  name: 'ShoppingCartSummary',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    summary: {
      type: Object,
      default: () => ({})
    }
  },
  vessel: {
    wrapper: {
      $attrs: 'all',
      textColor: 'grey-darkest',
      textSize: 'sm'
    }
  },
  computed: {
    totalItems: get('shoppingCart/totalItems'),
    quantity() {
      return this.$tc('eshop.item', this.totalItems || 0)
    },
    rows() {
      return Object.keys(this.summary).reduce((rows, key) => {
        const tag = key == 'total' ? 'strong' : 'span'
        let label = this.$t(`eshop.${key}`)
        let value = this.summary[key]

        if (value) {
          let show = true

          if (key == 'subtotal') {
            label = `${label} (${this.quantity})`
          }

          if (isObject(value)) {
            show  = (value.value || 0) > 0
            value = value.formatted
          }

          if (show && value) {
            rows.push({ key, label, value, tag })
          }
        }

        return rows
      }, [])
    }
  }
}
